'use client'
import { useState } from 'react'

interface Faq {
    question: string
    answer: string
}

interface Props {
    faqs: Faq[]
    merchantName: string
}

const MerchantFaqsAccordion = ({ faqs, merchantName }: Props) => {
    const [openIdx, setOpenIdx] = useState<number | null>(0)

    if (!faqs?.length) return null

    return (
        <div className="space-y-3">
            {faqs.map((faq, i) => (
                <div
                    key={i}
                    className={`border rounded-2xl overflow-hidden transition-all duration-300 ${openIdx === i ? 'bg-indigo-50/10 border-indigo-200/50 shadow-[0_4px_12px_rgba(79,70,229,0.03)]' : 'border-slate-150 bg-white hover:border-slate-200'}`}
                >
                    <button
                        onClick={() => setOpenIdx(openIdx === i ? null : i)}
                        className="w-full flex items-center justify-between px-4 py-3.5 text-left bg-transparent transition-colors cursor-pointer"
                    >
                        <span className="text-xs font-bold text-slate-800 pr-2 leading-snug">
                            {faq.question}
                        </span>

                        {/* Dynamic Interactive Icon Wrapper */}
                        <div className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${openIdx === i ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-500 group-hover:bg-slate-200'}`}>
                            <svg
                                className={`w-3.5 h-3.5 transition-transform duration-300 ${openIdx === i ? 'rotate-180' : ''}`}
                                fill="none" viewBox="0 0 24 24" stroke="currentColor"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </button>

                    {/* Collapsible Answer */}
                    <div className={`grid transition-[grid-template-rows] duration-300 ${openIdx === i ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                        <div className="overflow-hidden">
                            <div
                                className="px-4 pb-4 text-xs text-slate-600 border-t border-dashed border-indigo-100/50 pt-3 leading-relaxed"
                                dangerouslySetInnerHTML={{ __html: faq.answer }}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default MerchantFaqsAccordion
